import {createSlice} from "@reduxjs/toolkit";
import {setVolumeInventorySearchPageFilter} from "./actions";
import {VolumeInventorySearchCriteria} from "@ots-frontend/ots-data";

type VolumeInventorySearchPageState = {
    filter?: VolumeInventorySearchCriteria
}

const INITIAL_STATE: Readonly<VolumeInventorySearchPageState> = {
    filter: undefined,
};

const volumeInventorySearchPageSlice = createSlice({
    name: "ui/volume-inventory-search-page",
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            setVolumeInventorySearchPageFilter,
            (state, {payload}) => {
                state.filter = payload
            }
        );
    }
});

export const volumeInventorySearchPageReducer = volumeInventorySearchPageSlice.reducer;
